import { Grid } from '@mui/material';

import { useClientSupervisionEditable } from '../../../../hooks';
import { FHSelect } from '../../../base';

import type { IClientSupervision, SelectValueType } from '../../../../utils/types';

interface ResponseToTreatmentProps {
  clientSupervision: IClientSupervision | null;
  onUpdate: (data: IClientSupervision) => void;
}

function ResponseToTreatment(props: ResponseToTreatmentProps) {
  const { clientSupervision, onUpdate } = props;
  const isEditable = useClientSupervisionEditable();

  return (
    <>
      <Grid container>
        <Grid item md={12}>
          <FHSelect
            data-testid="responseToTreatmentDropDown"
            sx={{ minWidth: '150px', boxShadow: 'none' }}
            inputHeight={40}
            fullWidth
            disabled={!isEditable}
            options={[
              {
                value: 'Positive (Data indicates overall progress of goals)',
                label: 'Positive (Data indicates overall progress of goals)',
              },
              {
                value: 'Neutral (Data indicates neither progress nor regression of goals)',
                label: 'Neutral (Data indicates neither progress nor regression of goals)',
              },
              {
                value: 'Negative (Data indicated regression of goal(s))',
                label: 'Negative (Data indicated regression of goal(s))',
              },
            ]}
            value={clientSupervision?.response_to_treatment || ''}
            onUpdate={(value: SelectValueType) => {
              if (
                !clientSupervision ||
                (value !== 'Positive (Data indicates overall progress of goals)' &&
                  value !== 'Neutral (Data indicates neither progress nor regression of goals)' &&
                  value !== 'Negative (Data indicated regression of goal(s))')
              )
                return;
              onUpdate({ ...clientSupervision, response_to_treatment: value });
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default ResponseToTreatment;
